<!--
=========================
MODAL DIALOG ROOT
@description: Root dialog wrapper with all dynamic dialog classes applied.
=========================
-->
<div class="modal-dialog" [ngClass]="[dialogFullscreenClass, dialogSizeClass, dialogCenteredClass, dialogScrollableClass]">
  <div class="modal-content">

    <!--
    =========================
    MODAL HEADER SECTION
    @description: Modal header. Priority:
    1. HeaderTemplate (TemplateDirective)
    2. Projected content [modalTitle]
    3. Fallback to 'title' input property
    4. Corner close button (if enabled)
    =========================
    -->
    <div class="modal-header">
      <!-- 1. Template header -->
      @if (HeaderTemplate) {
        <ng-container *ngTemplateOutlet="HeaderTemplate.tempRef; context: HeaderTemplate?.tempContext" />
      } @else {
        <ng-content select="[modalTitle]">
          <h5 class="modal-title">{{title}}</h5>
        </ng-content>
      }
      <!-- 2. Projected or fallback header -->
      <!-- 3. Optional corner close button -->
      @if (cornerButton) {
        <ng-container *ngTemplateOutlet="cornerButtonTpl" />
      }
    </div>

    <!--
    =========================
    MODAL BODY SECTION
    @description: Body supports onboardingTemplate override, then:
    1. BodyTemplate (TemplateDirective)
    2. Projected content [modalBody]
    3. Fallback to 'bodyText' input property
    =========================
    -->
    @if (OnboardingTemplate) {
      <ng-container *ngTemplateOutlet="OnboardingTemplate.tempRef; context: OnboardingTemplate?.tempContext" />
    } @else {
      <div class="modal-body">
        <!-- 1. Template body -->
        @if (BodyTemplate) {
          <ng-container *ngTemplateOutlet="BodyTemplate.tempRef; context: BodyTemplate?.tempContext"></ng-container>
        } @else {
          <ng-content select="[modalBody]">{{bodyText}}</ng-content>
        }
        <!-- 2. Projected or fallback body -->
      </div>
    }

    <!--
    =========================
    MODAL FOOTER SECTION
    @description: Footer logic priority:
    1. FooterTemplate (TemplateDirective)
    2. Projected content [modalFooter]
    3. Fallback: default button(s)
    =========================
    -->
    <div class="modal-footer">
      <!-- 1. Template footer -->
      @if (FooterTemplate) {
        <ng-container *ngTemplateOutlet="FooterTemplate.tempRef; context: FooterTemplate?.tempContext" />
      } @else {
        <ng-content select="[modalFooter]">
          <button appButton variant="secondary" (click)="hide()">{{closeLabel}}</button>
          <button appButton variant="primary" (click)="accept()">{{acceptLabel}}</button>
        </ng-content>
      }
      <!-- 2. Projected or fallback footer -->
    </div>

  </div>
</div>

<!--
=========================
CORNER CLOSE BUTTON TEMPLATE
@description: Used when 'cornerButton' is true.
=========================
-->
<ng-template #cornerButtonTpl>
  <button type="button" class="btn-close" aria-label="Close" (click)="hide()"></button>
</ng-template>
